export default class Authentication {
  public static readonly SIGN_UP = '/sign-up';
  public static readonly LOGIN = '/login';
  public static readonly REFRESH = '/refresh';
  public static readonly FORGOT_PASSWORD = '/forgot-password';
  public static readonly VERIFY_SIGN_UP = '/sign-up/verify';
  public static readonly CONFIRM_PASSWORD_CHANGE = '/confirm-password-reset';
}
